import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {PointOptionsType} from 'highcharts';
import {Subject} from 'rxjs/internal/Subject';
import {MonitoringDetailsService} from '../../monitoring-details.service';
import {MetricType} from '../../../../../models-monitoring';
import {ChartPoint} from '../../../../../models';
import {HdUsageService} from './hd-usage.service';

@Component({
    selector: 'app-hd-usage',
    templateUrl: './hd-usage.component.html',
    styleUrls: ['./hd-usage.component.scss']
})
export class HdUsageComponent implements OnChanges, OnDestroy {

    @Input()
    metricId: number;

    @Input()
    metricType: MetricType;

    @Input()
    begin: Date;

    @Input()
    end: Date;

    @Input()
    resolution: number;

    @Input()
    serverId: number;

    dataSubject = new Subject<PointOptionsType[]>();

    chartPointList: ChartPoint[] = [];

    constructor(private service: HdUsageService,
                private monitoringDetailsService: MonitoringDetailsService) {
        this.monitoringDetailsService.changePath('monitoring-details', 'hd');
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.chartPointList = [];
        this.service.loadFromDbAndWebSocket(this.begin, this.end, this.metricType, this.metricId, this.serverId, this.resolution, this.chartPointList, this.dataSubject);
    }

    ngOnDestroy(): void {
        this.chartPointList = [];
        this.dataSubject = new Subject<PointOptionsType[]>();
        this.service.unSubscribe();
    }
}
